import { authRequest } from "../utils/netRequest";


export class ClosestCarsService {
  async getCars(location) {
    if (!location) return [];
    return await authRequest({
      url: "/vehicles/closest",
      method: "get",
      params: location,
    });
  }
}

export default new ClosestCarsService();


